import { render, staticRenderFns } from "./ShowEditDeleteSlide.vue?vue&type=template&id=61f3fa84&scoped=true&"
import script from "./ShowEditDeleteSlide.vue?vue&type=script&lang=js&"
export * from "./ShowEditDeleteSlide.vue?vue&type=script&lang=js&"
import style0 from "./ShowEditDeleteSlide.vue?vue&type=style&index=0&id=61f3fa84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f3fa84",
  null
  
)

export default component.exports